// Types
import { ErrorNames } from './ErrorNames';
/**
 * @description Returns an instance of error with the name set to FetchError
 *
 * @return { Error } error with name set to FetchError
 */
export var getInvalidStateMachineActionError = function (action, state) {
    var error = new Error("Invalid action '" + action + "' for the state '" + state + "'");
    error.name = ErrorNames.INVALID_STATE_MACHINE_ACTION;
    return error;
};
//# sourceMappingURL=getInvalidStateMachineActionError.js.map